var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Grid, Button } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MapIcon from '@mui/icons-material/Map';
import ManifestMapContainer from "./ManifestMapContainer";
import DateRangeSlider from "./DateRangeSlider";
import UVDialog from "./UVDialog";
import ManifestCard from "./ManifestCard";
import ManifestMapCopyright from "./ManifestMapCopyright";
export function CollectionMap(_a) {
    var collection = _a.collection, viewerPath = _a.viewerPath;
    var _b = useState(false), filterByDate = _b[0], setFilterByDate = _b[1];
    var _c = useState(true), showMap = _c[0], setShowMap = _c[1];
    var _d = useState([]), manifests = _d[0], setManifests = _d[1];
    var _e = useState(null), focusManifest = _e[0], setFocusManifest = _e[1];
    var _f = useState([]), filteredManifests = _f[0], setFilteredManifests = _f[1];
    var _g = useState([0, 2022]), dateRange = _g[0], setDateRange = _g[1];
    var _h = useState(null), viewerManifest = _h[0], setViewerManifest = _h[1];
    var onSelectFocusManifest = function (manifest) {
        if (manifest === focusManifest) {
            setFocusManifest(null);
        }
        else {
            setFocusManifest(manifest);
        }
    };
    var onViewerClose = function () {
        setViewerManifest(null);
    };
    useEffect(function () {
        var m = collection.manifests();
        setManifests(m);
    }, [collection]);
    useEffect(function () {
        var _filteredManifests = manifests;
        if (filterByDate) {
            var earliestYear_1 = dateRange[0];
            var latestYear_1 = dateRange[1];
            _filteredManifests = manifests.filter(function (manifest) {
                var year = manifest === null || manifest === void 0 ? void 0 : manifest.navDateYear();
                return (year !== null) && year <= latestYear_1 && year >= earliestYear_1;
            });
            _filteredManifests.sort(function (a, b) { return (a.navDateYear() || 0) - (b.navDateYear() || 0); });
        }
        setFilteredManifests(_filteredManifests);
    }, [manifests, filterByDate, dateRange]);
    var displayControls = function () {
        return _jsxs(Box, __assign({ pt: 4, pb: 3, bgcolor: "white", hidden: collectionHasNoNavDate(collection) && collectionHasNoNavPlace(collection) }, { children: [_jsx(Box, __assign({ ml: 7, component: "span" }, { children: _jsx(Button, __assign({ hidden: collectionHasNoNavPlace(collection), size: "small", variant: showMap ? "contained" : "outlined", onClick: function (e) { return setShowMap(!showMap); }, startIcon: _jsx(MapIcon, {}, void 0) }, { children: showMap ? "Hide map" : "Show map" }), void 0) }), void 0), _jsx(Box, __assign({ ml: 2, component: "span", hidden: collectionHasNoNavDate(collection) }, { children: _jsx(Button, __assign({ size: "small", variant: filterByDate ? "contained" : "outlined", onClick: function (e) { return setFilterByDate(!filterByDate); }, startIcon: _jsx(CalendarMonthIcon, {}, void 0) }, { children: filterByDate ? "Remove date limit" : "Limit by date range" }), void 0) }), void 0), _jsx(Box, __assign({ ml: 4, component: "span", width: 4, hidden: collectionHasNoNavDate(collection) }, { children: _jsx(DateRangeSlider, { collection: collection, disabled: !filterByDate, dateRange: dateRange, setDateRange: setDateRange }, void 0) }), void 0)] }), void 0);
    };
    var mapCopyright = function () {
        return _jsx(Box, __assign({ hidden: !(collection === null || collection === void 0 ? void 0 : collection.manifests().some(function (manifest) { return manifest.navPlace(); })) }, { children: _jsx(ManifestMapCopyright, {}, void 0) }), void 0);
    };
    var collectionHasNoNavPlace = function (collection) {
        return !(collection === null || collection === void 0 ? void 0 : collection.manifests().some(function (manifest) { return manifest.navPlace(); }));
    };
    var collectionHasNoNavDate = function (collection) {
        return !(collection === null || collection === void 0 ? void 0 : collection.manifests().some(function (manifest) { return manifest.navDateYear(); }));
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ sx: { position: "sticky", top: 0, zIndex: 5 } }, { children: [_jsx(Box, __assign({ className: "row", hidden: collectionHasNoNavPlace(collection) || !showMap }, { children: _jsx(ManifestMapContainer, { manifests: filteredManifests, focus: focusManifest }, void 0) }), void 0), displayControls()] }), void 0), _jsx(UVDialog, { manifest: viewerManifest, handleClose: onViewerClose, viewerPath: viewerPath }, void 0), _jsx(Grid, __assign({ container: true, mt: 0, mr: 2, ml: 2, spacing: 2, p: 1, sx: { overflowY: "auto" } }, { children: filteredManifests.map(function (manifest, idx) { return (_jsx(Grid, __assign({ item: true, xs: 4, sm: 3, m: 2, lg: 2 }, { children: _jsx(ManifestCard, { manifest: manifest, onSelect: onSelectFocusManifest, isSelected: manifest === focusManifest, onShowInViewer: setViewerManifest }, void 0) }), manifest.uri)); }) }), void 0), mapCopyright()] }, void 0));
}
